module.exports = __webpack_public_path__ + "img/19-1.bedf1b58.png";